import global from "./global";
import filterCategory from "./filterCategory";

export default {
  state: () => ({}),
  modules: {
    global,
    filterCategory
  }
};
